define('responsive-gameday/views/Monitor/ViewModels/BoxscoreViewModel',['require','exports','module','message-service/message-service','./ViewModelBase','../Events/ViewModelUpdateEvents','../Events/SceneStateEvents','GameDayCore/GDModel/enums/datasources/Datasources','extant/extant'],function(require,exports,module) {
    var MessageService = require("message-service/message-service"),
        ViewModelBase = require("./ViewModelBase"),
        UpdateEvents = require("../Events/ViewModelUpdateEvents"),
        SceneEvents = require("../Events/SceneStateEvents"),
        Datasources = require("GameDayCore/GDModel/enums/datasources/Datasources"),
        exists = require("extant/extant");
    var Superclass;

    function BoxscoreViewModel() {
        Superclass.constructor.call(this);

        this.eventType = UpdateEvents.UPDATE_BOXSCORE;
        MessageService.addListener.call(this, UpdateEvents.REQUEST_BOX_DATA, this.handleUpdateRequest);
    }

    ViewModelBase.spawn(BoxscoreViewModel).define({
        moldData: function(flavor) {
            var boxData = { },
                renderOrder = ['away', 'home'],
                innState = this.gameData.play.inning_state;

            if (exists(this.gameData, "boxscore,play,game,bench")) {
                boxData = this.gameData.boxscore;

                boxData.teams = {
                    home: this.gameData.game.home,
                    away: this.gameData.game.away
                };

                boxData.teams.home.display = this.gameData.linescore.home_sport_code == "mlb" ? this.gameData.game.home.name_brief : this.gameData.game.home.name_full;
                boxData.teams.away.display = this.gameData.linescore.home_sport_code == "mlb" ? this.gameData.game.away.name_brief : this.gameData.game.away.name_full;

                boxData.benches = {
                    home: this.gameData.bench.home,
                    away: this.gameData.bench.away
                };
                
                // if(~~boxData.home_runs >= ~~boxData.away_runs){
                //     renderOrder = ['home', 'away'];
                // }
                // boxData.renderOrder = renderOrder;
                boxData.renderTeamOrder = [ boxData.teams[renderOrder[0]], boxData.teams[renderOrder[1]]];
                boxData.renderBoxOrder = [ boxData[renderOrder[0]], boxData[renderOrder[1]]];
                boxData.renderBenchOrder = [ boxData.benches[renderOrder[0]], boxData.benches[renderOrder[1]]];

                boxData.activeBatter = exists(this.gameData, 'play.batter') ? this.gameData.play.batter.pid : null;
                boxData.isActive = function () {
                    return boxData.linescore.status_ind !== "F" && this.id === boxData.activeBatter ? true : false;
                };
                boxData.batOrder = function () {
                    var oddOrEven = this.bo.substring(0,1) % 2 ? 'odd' : 'even';
                    return 'bat-order-' + oddOrEven;
                }
                boxData.isNewHalfInning = exists(this.stateUpdates, SceneEvents.NEW_HALF_INNING);
                boxData.isHomeBatting = ((innState === 'Top' || innState === 'Middle')) ? false : true;
                this.dataPack = boxData;
                this.dispatchUpdates(this.eventType, boxData);
            }
        },
        handleUpdateRequest : function(inning){
            var that = this;

            this.gameData = GDC.getGameData();
            this.moldData();

        }
    });

    Superclass = BoxscoreViewModel.superclass;
    return BoxscoreViewModel;
});
